import React from "react";
import type { ApiClient } from "../app/api/client";
import { DocumentBlobPreviewContent } from "./DocumentBlobPreviewContent";

export type PersonDocumentPreviewRow = {
  id: string;
  personId?: string;
  category?: number;
  fileName: string;
  title?: string | null;
  description?: string | null;
  contentType: string;
  size?: number;
  createdAt?: string;
};

type PersonDocumentPreviewContentProps = {
  api: ApiClient;
  personId?: string;
  doc: PersonDocumentPreviewRow;
  documentUrlBase?: string;
  inlineUrl?: string;
  downloadUrl?: string;
  text: (key: string) => string;
  zoomStorageKey?: string;
};

export function DocumentPreviewContent({
  api,
  personId,
  doc,
  documentUrlBase,
  inlineUrl,
  downloadUrl,
  text,
  zoomStorageKey
}: PersonDocumentPreviewContentProps) {
  const docUrlBase = documentUrlBase
    ?? (personId ? `/api/v1/persons/${encodeURIComponent(personId)}/documents/${encodeURIComponent(doc.id)}` : "");
  const previewUrl = inlineUrl ?? (docUrlBase ? `${docUrlBase}${docUrlBase.includes("?") ? "&" : "?"}inline=true` : "");
  const effectiveDownloadUrl = downloadUrl ?? docUrlBase;

  return (
    <DocumentBlobPreviewContent
      api={api}
      previewUrl={previewUrl}
      downloadUrl={effectiveDownloadUrl}
      fileName={doc.fileName}
      title={doc.title || doc.fileName}
      contentType={doc.contentType}
      text={text}
      zoomStorageKey={zoomStorageKey}
    />
  );
}

export const PersonDocumentPreviewContent = DocumentPreviewContent;
